/**
 * アプリケーション全体で使用する定数
 */

// レイアウト（レスポンシブ）
/**
 * ブレークポイント一覧（CSS と同期すること）
 * - COMPACT_LAYOUT_BREAKPOINT (1024): 認証後サイドバー・請求カード・ライセンスサマリー
 * - MOBILE_BREAKPOINT (900): 公開ナビ・製品/料金カルーセル・招待コード詳細
 * - 768px: HubContact 確認 1 列・法務ページ（CSS のみ）
 * - 480px: トースト・ヒーロー縮小（CSS のみ）
 * 詳細: temp/userhub-responsive-high-medium-spec.md
 */
/** 狭いモバイル向け（ヒーロー縦並び等）— CSS max-width: 900px と一致 */
export const MOBILE_BREAKPOINT = 900;
/** コンパクトレイアウト（認証後サイドバー・公開ナビのハンバーガー等）— CSS max-width: 1024px と一致 */
export const COMPACT_LAYOUT_BREAKPOINT = 1024;

// ライセンス関連
export const LICENSE_LIMIT = 30;
/** ライセンス最終利用日の翌朝カットオフ（JST）— server/config/constants.js と同期 */
export const LICENSE_USAGE_CUTOFF_HOUR_JST = 6;

// アニメーション関連
export const MODAL_ANIMATION_DURATION = 200; // ms

// パスワード関連（8文字以上・英数字記号で統一）
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_CHARS = {
  LOWERCASE: 'abcdefghijklmnopqrstuvwxyz',
  UPPERCASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  NUMBERS: '0123456789',
  SPECIAL: '!@#$%^&*()_+-=[]{}|;:,.<>?'
};

// 画像関連
export const IMAGE_MAX_SIZE = 5 * 1024 * 1024; // 5MB
export const IMAGE_ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

// その他
export const POSTAL_CODE_AUTO_SEARCH_DELAY = 100; // ms

